import React from "react";
import { Link } from "react-router-dom";
import ScoutAndChoosePage from "./LesQuisScoutBeta";

export default function ScoutFixedLakePage() {
  const startFlow = new URLSearchParams(window.location.search).get("start_flow") === "1";

  return (
    <div className="catchcompass-fixed-lake-scout">
      <style>{`
        .catchcompass-fixed-lake-scout section:first-of-type > label:first-child,
        .catchcompass-fixed-lake-scout section:first-of-type > select,
        .catchcompass-fixed-lake-scout section:first-of-type > select + button {
          display: none !important;
        }
      `}</style>

      <div className="mx-auto w-full max-w-3xl px-3 pt-3 sm:px-6">
        {startFlow ? (
          <>
            <div className="grid grid-cols-3 gap-2" aria-label="Start Fishing progress">
              <div className="rounded-lg border border-success bg-success-weak px-2 py-2 text-center text-xs font-semibold text-success">
                ✓ Water
              </div>
              <div className="rounded-lg border border-accent bg-accent/10 px-2 py-2 text-center text-xs font-semibold text-accent">
                2 · Peg
              </div>
              <div className="rounded-lg border border-border bg-raised px-2 py-2 text-center text-xs font-semibold text-secondary">
                3 · Plan
              </div>
            </div>
            <div className="mt-3 flex items-start justify-between gap-3 rounded-xl border border-accent/30 bg-raised px-4 py-3">
              <div>
                <p className="text-sm font-semibold text-primary">{"Peg · Scout & Choose"}</p>
                <p className="mt-1 text-xs leading-5 text-secondary">
                  Pick a mapped peg you already know, or scout the lake and compare swims before choosing.
                </p>
              </div>
              <Link to="/scout" className="shrink-0 text-xs font-semibold text-accent">
                Change water
              </Link>
            </div>
          </>
        ) : (
          <div className="flex items-center justify-between gap-3 rounded-lg border border-border bg-inset px-3 py-2 text-xs text-secondary">
            <span>Water already selected in Start Fishing</span>
            <Link to="/scout" className="font-semibold text-accent">
              Change water
            </Link>
          </div>
        )}
      </div>

      <ScoutAndChoosePage />
    </div>
  );
}
